import { makeStyles } from '@material-ui/styles';


export const style = (theme) => ({
  root: {
    pointerEvents: 'none',
    
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: theme.spacing(2),
    
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.appBar + 2
  },
  
  widgetPapper: {
    pointerEvents: 'all',
    transition: 'left 0.15s ease-in, top 0.15s ease-in',
    
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    
    position: 'relative',
    left: '100%',
    maxWidth: 500
  },
  
  widgetPapperVisible: {
    left: 0
  },
  
  progressBlock: {
    position: 'relative'
  },
  
  progressPercent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },
  
  widgetControlBtns: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  
  widgetStateSuccess: {
    color: theme.palette.success.main
  },
  
  widgetStateError: {
    color: theme.palette.error.main
  },
  
  widgetStateProgress: {
    color: theme.palette.primary.main
  }
});

export const useStyle = makeStyles(style);
